jQuery_T4NT(document).ready(function ($) {

	/**
	 *  Variant selection changed
	 *  data-variant-toggle="{{variant.id}}"
	 */
	
    $(document).on("variant:changed", function (evt) {
		// console.log( evt.currentVariant );
		// $('[data-variant-toggle]').hide(0);
		// $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	});

    /*
    $(document).on("click", ".custom_item_country_mb", function(){
        console.log("click from item mnu2");
        var selected_country = $(this).attr('data-countryCode');

        if(location.href.indexOf("?") == -1){
                location.href = `${location.href}?country=${selected_country}`;
            } else {
                if(location.href.indexOf("country") == -1)
                {
                  location.href = `${location.href}&country=${selected_country}`;
                }
                else{
                  //replace country param
                  var url = location.href;  
                  var urlparts = url.split('?');
                  if (urlparts.length >= 2) {
                      var prefix = encodeURIComponent('country')+'=';
                      var pars = urlparts[1].split(/[&;]/g);
                      for (var i = pars.length; i-- > 0;) {    
                          if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                              pars.splice(i, 1);
                          }
                      }
                      url = urlparts[0]+'?'+pars.join('&');
                      location.href = `${url}&country=${selected_country}`;
                  }
                }
            }
    });
    */
  
	// Add to cart from home page
	$('.ecom-product-single__add-to-cart--submit').on('click', function (e) {
		e.preventDefault()
		fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					items: [{
						id: e.target.getAttribute('data-variant-id'),
						quantity: 1,
					}, ],
				}),
			})
			.then((res) => res.json())
			.then(() => {
				T4SThemeSP.getToFetchSection("?sections=cart_data,mini_cart", "json").then(t => {
					T4SThemeSP.Cart.renderContents(t, false)
				});
			})
			.then(() => {
				$('.t4s-site-nav__cart a').trigger('click'); 
			}).catch((e) => {
				console.error('Something Went Wrong: ', e);
			}).finally(() => {
				setTimeout(function(){
					sidecartGammification();
				}, 500);
			});
	});
	// End Add to cart from home page
});

// document.addEventListener("DOMContentLoaded", ()=>{
//     const bodyContainer = document.querySelector("body");

//     bodyContainer.onclick = ( {target} ) => {
//       if(target.classList.contains("upsell-add-to-cart")) {
//         const variantId = target.getAttribute("data-variant-id");
//         var formData = {
//           items: [{
//             id: variantId,
//             quantity: 1
//           }]
//         };
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           body: JSON.stringify(formData)
//         })
//         .then(response => response.json())
//         .then(data => {
// 			T4SThemeSP.getToFetchSection("?sections=cart_data,mini_cart", "json").then(t => {
// 				T4SThemeSP.Cart.renderContents(t, false)
// 			});
//         })
//         .catch(error => {
//           console.error('Error adding product to cart:', error);
//           document.getElementById('cart-message').textContent = 'Failed to add product to cart.';
//         });
//       }
//     }
//   })

// Accordion by WebSensePro.com
$(function () {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();

	$(".accordion > .accordion-item").click(function () {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});

document.addEventListener('DOMContentLoaded', (e) => {

    console.log("from DOMContentLoaded");
  
	const buttonBundle = document.querySelector('.rutine-atc button');
    
	if(buttonBundle){
		buttonBundle.addEventListener('click', (e) => {
			//Clearing the cart
			fetch('/cart/clear.js').then(response => {
				fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						items: [
							{
								id: 41433982828695,
								quantity: 1,
							}, 
							{
								id: 41433987383447,
								quantity: 1,
							}, 
							{
								id: 42498588901527,
								quantity: 1,
							}, 
						],
					}),
				}).then(() => {
					T4SThemeSP.getToFetchSection("?sections=cart_data,mini_cart", "json").then(t => {
						T4SThemeSP.Cart.renderContents(t, false)
					});
				})
				.then(() => {
					$('.t4s-site-nav__cart a').trigger('click'); 
				}).catch((e) => {
					console.error('Something Went Wrong: ', e);
				}).finally(() => {
					setTimeout(function(){
						sidecartGammification();
					}, 500);
				});
			});
		});
	}
});